import { DatePipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sqep-footer',
  imports: [DatePipe, NgOptimizedImage],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  copyrightDate = Date.now();
  readonly isSignedIn = input<boolean>();
  readonly navbarBgClass = input<string>();
  readonly guiBuildVersion = input<string>();
  readonly apiBuildVersion = input<string>();
  readonly csodApiBuildVersion = input<string>();
}
